// src/api/chatApi.js
const BASE_URL = "https://revie.triciclogo.com/chat";

async function apiRequest(endpoint, method = "GET", data) {
  const options = {
    method,
    headers: { "Content-Type": "application/json" },
  };
  if (data) options.body = JSON.stringify(data);

  const res = await fetch(`${BASE_URL}/${endpoint}`, options);
  if (!res.ok){
    //throw new Error(`API error ${res.status}`);
    console.error(`API error ${res.status}`);
    return {};
  }
  return res.json();
}
//https://revie.triciclogo.com/chat/conversation/messages/Seba
//https://revie.triciclogo.com/chat/conversation/messages/Seba
export const ChatAPI = {
    getStores: () => apiRequest("store/list"),
    getConversations: (storeId) => apiRequest(`conversation/list/${storeId}`),
    getMessages: (conversationId) =>
        apiRequest(`conversation/messages/${conversationId}`),
    sendMessage: (storeId, customerId, message) =>
        apiRequest("send", "POST", {
        store_id: storeId,
        customer_id: customerId,
        message,
        }),
    updateTraining: (storeId, training) =>
        apiRequest("store/train", "POST", {
        store_id: storeId,
        training_data: training,
        }),
    saveExamples: (storeId, examples) =>
        apiRequest("store/examples", "POST", {
          store_id: storeId,
          examples,
        }),
    getStoreExamples: (storeId) =>
        apiRequest(`store/examples/${storeId}`),
};
